import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-chargebee-success',
  standalone: true,
  imports: [CommonModule, CardModule, ButtonModule],
  templateUrl: './chargebee-success.html',
  styleUrls: ['./chargebee-success.scss']
})
export class ChargebeeSuccess implements OnInit {

  constructor(private router: Router) {}

  ngOnInit(): void {
  }

  goToCompanyConfiguration(): void {
    this.router.navigate(['/admin/company-configuration']);
  }
}
